import { render, staticRenderFns } from "./language-dropdown.vue?vue&type=template&id=7a15d33c"
import script from "./language-dropdown.vue?vue&type=script&lang=js"
export * from "./language-dropdown.vue?vue&type=script&lang=js"
import style0 from "./language-dropdown.vue?vue&type=style&index=0&id=7a15d33c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports